module.exports = __webpack_public_path__ + "img/cube.fe.ec50028a.webp";